import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import userStore from '../../Stores/User';
import { updateUserCookieConsent } from '../../audiblogsApi';
import './CookieConsent.scss';

const CookieConsent = observer(() => {
  // Temporarily hidden
  return null;
  
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user is signed in and has cookie consent
    if (userStore.isSignedIn && userStore.cookieConsent) {
      // User has already given consent, don't show banner
      setIsVisible(false);
      return;
    }

    // Check localStorage as fallback for non-signed-in users
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setIsVisible(true);
    }
  }, [userStore.isSignedIn, userStore.cookieConsent]);

  const handleAcceptAll = () => {
    const allConsent = {
      essential: true,
      analytics: true,
      preferences: true,
      marketing: true
    };
    saveConsent(allConsent);
  };

  const handleEssentialOnly = () => {
    const essentialConsent = {
      essential: true,
      analytics: false,
      preferences: false,
      marketing: false
    };
    saveConsent(essentialConsent);
  };

  const saveConsent = async (consentPreferences) => {
    // Save to localStorage for non-signed-in users
    localStorage.setItem('cookie-consent', JSON.stringify({
      preferences: consentPreferences,
      timestamp: new Date().toISOString()
    }));

    // If user is signed in, save to database
    if (userStore.isSignedIn && userStore.user?.user_id) {
      try {
        await updateUserCookieConsent(userStore.user.user_id, consentPreferences);
        userStore.updateCookieConsent(consentPreferences);
      } catch (error) {
        console.error('Failed to save cookie consent to database:', error);
      }
    }

    setIsVisible(false);
    updateCookiePreferences(consentPreferences);
  };

  const updateCookiePreferences = (prefs) => {
    if (!prefs.analytics) {
      // Disable analytics cookies
      // window['ga-disable-UA-XXXXX-Y'] = true;
    }
    if (!prefs.marketing) {
      // Disable marketing cookies
    }
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-content">
        <p>
          Cookies - <a href="/privacy" className="privacy-link">Policy</a>
        </p>
        <div className="cookie-actions">
          <button 
            onClick={handleEssentialOnly} 
            className="btn-secondary"
            style={{
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              color: '#fff',
              border: '1px solid rgba(255, 255, 255, 0.3)',
              minWidth: '120px',
              minHeight: '40px'
            }}
          >
            Essential Only
          </button>
          <button 
            onClick={handleAcceptAll} 
            className="btn-primary"
            style={{
              backgroundColor: '#007bff',
              color: '#fff',
              border: 'none',
              minWidth: '120px',
              minHeight: '40px'
            }}
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
});

export default CookieConsent; 